export default "__VITE_ASSET__DDBHXszi__"